import React from "react";
import { Navbar } from "@/components/Navbar";
import { Seo } from "@/components/Seo";
import { OwnerSalesDocsPanel } from "@/components/OwnerSalesDocsPanel";
import { IntroNote } from "@/components/IntroNote";

/**
 * Dedicated home for Sales, partner and strategy documents.
 * The panel already lived on /tenants but was hard to find — this route gives
 * partner-facing assets (like the IBM board decks + signals catalogue) their
 * own address, discoverable from the top-level "Platform" menu.
 */
export default function SalesDocsPage() {
  return (
    <div className="min-h-screen bg-ek-canvas">
      <Navbar />
      <Seo
        title="Sales & partner documents"
        description="Owner library of branded board decks, partner packs and strategy documents."
        path="/sales-docs"
      />
      <main className="mx-auto max-w-5xl px-6 py-8" data-testid="sales-docs-page">
        <div>
          <p className="ek-eyebrow">Owner · Sales enablement</p>
          <h1 className="ek-heading mt-1 text-3xl">Sales, partner & strategy documents</h1>
        </div>
        <IntroNote className="mt-4">
          One home for every branded artefact the founding team hands over during
          partner and prospect conversations — board decks, signals catalogues,
          one-page leave-behinds and technical architecture papers. Every
          download is Owner-only and audit-logged. To swap the partner name
          across the whole pack: <code>PARTNER_NAME=&quot;Company X&quot; python3
          backend/scripts/build_partner_materials.py</code>.
        </IntroNote>
        <OwnerSalesDocsPanel />
      </main>
    </div>
  );
}
